import React from 'react';
import clsx from 'clsx';
import useStyles from './useStyles';

import { FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core';

import {
  InfoOutlined,
  LockOpenOutlined,
  LockOutlined
} from '@material-ui/icons';

import { Controller, useFormContext } from 'react-hook-form';

import {
  CustomizedTooltip,
  CustomizedTypography
} from '@components/Customized';

import { IRequestState } from '@modules/request';

interface Props {
  handleUpdateRfqInfo: (payload: Partial<IRequestState>) => void;
}

const RequestForQuotationSecurity = ({ handleUpdateRfqInfo }: Props) => {
  const classes = useStyles();
  const { control } = useFormContext();

  return (
    <section
      className={clsx(
        classes['rfq-security-setting'],
        classes['rfq-info-section']
      )}
    >
      <div className="tooltip-title-box">
        <CustomizedTypography
          className="title"
          align="center"
          color="textPrimary"
        >
          도면 보안 설정을 해주세요
        </CustomizedTypography>

        <CustomizedTooltip
          className="tooltip"
          title={
            <CustomizedTypography color="inherit" variant="body2">
              "허용된 파트너만 도면 다운로드" 가능을 선택 한 경우, 파트너는
              요청서의 도면을 CAPA 도면 뷰어로만 확인할 수 있으며, 다운로드하기
              위해 서는 고객님의 권한 설정이 필요합니다.
              <br />
              <br />
              파트너는 상담 진행 중 필요 시 고객님에게 다운 로드 권한을 요청할
              수 있으며, 고객님은 권한을 부여할 수 있습니다.
            </CustomizedTypography>
          }
        >
          <InfoOutlined />
        </CustomizedTooltip>
      </div>

      <Controller
        name="publicOpen"
        control={control}
        defaultValue={true}
        render={(render) => {
          return (
            <RadioGroup
              {...render}
              onChange={(e) => {
                render.onChange(e.target.value === 'open');
                handleUpdateRfqInfo({
                  publicOpen: e.target.value === 'open'
                });
              }}
              className="radioGroup"
            >
              <FormControlLabel
                className={clsx('radioBox', {
                  'selected': render.value
                })}
                label={
                  <Grid container direction="column" className="radioInnerBox">
                    <Grid item className="radio-label-box">
                      <LockOpenOutlined />
                      <CustomizedTypography className="radio-label">
                        모든 파트너 도면 다운로드 가능
                      </CustomizedTypography>
                    </Grid>
                    <Grid item className="radio-label-list">
                      <CustomizedTypography
                        variant="body2"
                        color={render.value ? 'textPrimary' : 'textSecondary'}
                        gutterBottoms={4}
                      >
                        • 모든파트너가 도면을 다운로드할 수 있습니다.
                      </CustomizedTypography>
                      <CustomizedTypography
                        variant="body2"
                        color={render.value ? 'textPrimary' : 'textSecondary'}
                        gutterBottoms={4}
                      >
                        • 가장 정확한 견적을 받을 수 있습니다.
                      </CustomizedTypography>
                      <CustomizedTypography
                        variant="body2"
                        color={render.value ? 'textPrimary' : 'textSecondary'}
                      >
                        • 다운로드 권한은 보안 설정에서 수정할 수 있습니다.
                      </CustomizedTypography>
                    </Grid>
                  </Grid>
                }
                control={
                  <Radio value="open" color="primary" checked={render.value} />
                }
              />
              <FormControlLabel
                className={clsx('radioBox', {
                  'selected': !render.value
                })}
                label={
                  <Grid container direction="column" className="radioInnerBox">
                    <Grid item className="radio-label-box">
                      <LockOutlined />
                      <CustomizedTypography className="radio-label">
                        허용된 파트너만 도면 다운로드 가능
                      </CustomizedTypography>
                    </Grid>

                    <Grid item className="radio-label-list">
                      <CustomizedTypography
                        variant="body2"
                        color={!render.value ? 'textPrimary' : 'textSecondary'}
                        gutterBottoms={4}
                      >
                        • 신뢰하는 파트너에게만 다운로드 권한을 부여합니다.
                      </CustomizedTypography>
                      <CustomizedTypography
                        variant="body2"
                        color={!render.value ? 'textPrimary' : 'textSecondary'}
                        gutterBottoms={4}
                      >
                        • 모든 파트너는 도면뷰어에서 도면형상을 볼 수 있습니다.
                      </CustomizedTypography>
                      <CustomizedTypography
                        variant="body2"
                        color={!render.value ? 'textPrimary' : 'textSecondary'}
                      >
                        • 다운로드 권한은 보안 설정에서 수정할 수 있습니다.
                      </CustomizedTypography>
                    </Grid>
                  </Grid>
                }
                control={
                  <Radio
                    value="limit"
                    color="primary"
                    checked={!render.value}
                  />
                }
              />
            </RadioGroup>
          );
        }}
      />
    </section>
  );
};

export default RequestForQuotationSecurity;
